import { useFeatureFlags } from 'common/hooks';

const useInsightV2WoltPlusHidden = (entityCountry: Country | string) => {
  const featureFlagName = 'merchant_admin_insights_v2_wolt_plus_hidden';

  const { data: featureFlags, isLoading } = useFeatureFlags([featureFlagName], {
    feature_country: entityCountry,
  });

  return { isLoading, isWoltPlusHidden: featureFlags?.[featureFlagName] === 'on' };
};

export default useInsightV2WoltPlusHidden;
